import { toast } from 'vue-sonner'

export function useNotify() {
  return {
    error: (message: string) => {
      console.error(message)
      toast.error(message)
    },
    success: (message: string) => toast.success(message),
    warning: (message: string) => {
      console.warn(message)
      toast.warning(message)
    },
    info: (message: string) => toast.info(message)
  }
}
